import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { SWRProvider, MainProvider } from '@jokerdad/providers'
import { RandomJoke, SearchJoke } from '@jokerdad/components'

function App() {
  return (
    <MainProvider>
      <SWRProvider>
        <Router>
          <RandomJoke />
          <SearchJoke />
        </Router>
      </SWRProvider>
    </MainProvider>
  )
}

export default App
